import React, { useContext, useEffect, useState } from "react";
import SidebarLayout from "../components/shared/SidebarLayout";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import AuthContext from "../context/AuthContext";
import obj from "../Utils/helpers";
import { isEmpty, startCase } from "lodash";
import { IoIosArrowForward } from "react-icons/io";
import { Button, Table } from "react-bootstrap";
const Ptransferlog = () => {
  const { user } = useContext(AuthContext);
  const [data, setData] = useState({});
  const [listing, setListing] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });
  const handel = () => {
    setFilter({
      ...filter,
      page: filter?.page + 1,
    });
    getData(
      {
        ...filter,
        page: filter?.page + 1,
      },
      "add"
    );
  };
  const getData = async (obj = filter, type) => {
    const { status, data } = await apiGet(apiPath.p2ptransferLog, obj);
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
        if (type == "add") {
          setListing([...listing, ...data?.results?.data]);
        } else {
          setListing(data?.results?.data);
        }
      }
    }
  };
  useEffect(() => {
    if (!isEmpty(user)) {
      getData();
    }
  }, [user]);

  return (
    <SidebarLayout heading={"P2P Transfer Log"}>
      <div className="p-3 pt-4 inner-sidebar-content">
        {listing?.length > 0
          ? listing?.map((res) => {
              return (
                <div className="balance-deposit-sec mt-3">
                  <Table bordered className="rounded overflow-hidden bg-white">
                    <thead>
                      <tr>
                        <th colSpan="4">{obj.dateFormat(res?.createdAt)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td width="50%">
                          {startCase(res?.transactionType)}
                          <strong
                            className={`d-block ${
                              res?.transactionType !== 'debit'
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            {res?.transactionType !== 'debit'
                              ? res?.amount
                              : `(${res?.amount})`}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ fontSize: "14px" }}
                          width="50%"
                          colSpan="4"
                        >
                          Remark
                          <strong className="d-block">{res?.remark}</strong>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              );
            })
          : "No Record Found"}
        {data?.hasNextPage && (
          <div className="w-100 d-flex justify-content-center align-items-center">
            <Button
              onClick={handel}
              style={{ background: "black", border: "none" }}
            >
              Show More <IoIosArrowForward />
            </Button>
          </div>
        )}
      </div>
    </SidebarLayout>
  );
};

export default Ptransferlog;
